export interface TaskLoadingState {
  task: boolean;
  action: boolean;
  skip: boolean;
  subtaskIndex: number;
  metricId: string;
  metricStatus: string; // loading, success, ''
  checkbox: boolean;
  attributeId?: string;
}

export const EMPTY_TASK_LOADING_STATE: TaskLoadingState = {
  task: true,
  action: false,
  skip: false,
  subtaskIndex: null,
  metricId: '',
  metricStatus: '',
  checkbox: false,
};
